import { PET_AVATAR } from "@src/mock/data/pet";

export default {
  title: '上傳會員媒體',
  type: 'post',
  body: [
    {
      title: '成功',
      body: {
        "code": 200,
        "message": "success",
        "status": "SUCCESS",
        "data": {
          "items": {
            "path": PET_AVATAR
          },
        }
      }
    },
  ]
}

